import { Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'rcs-kd-job-detail',
  templateUrl: 'rcs-kd-job-detail.html'
})
export class RcsKdJobDetailComponent implements OnInit{

  @Input() job:any;

  constructor() {}

  ngOnInit():void{
  }

  public isJobBeginnenVisible() {
    return (localStorage.getItem('manual_sync_needed') === null);
  }

  private getDescription() {
    return this.job.description.replace(/\n/ig, '<br/>');
  }
}



// WEBPACK FOOTER //
// ./src/components/rcs-kd-job-detail/rcs-kd-job-detail.ts